import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBar',
  setup(__props) {

// No additional setup or imports are needed

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    color: "green",
    dark: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Makruu.com")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})